// Copyright (C) 2020-2023 Berkadia Commercial Mortgage, LLC - All Rights Reserved
// import API from '../../../apis/API'
import APIInterceptor from '../../../apis/APIInterceptors'
import propertySearchAPIs from '../../../apis/propertySearchAPIs'

const getCompsReport = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.getCompsReport, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const fetchDeals = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.fetchDeals, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const addListToDeal = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.addListToDeal, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const deleteListFromDeal = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.deleteListFromDeal, payload, 'delete')
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const fetchPropertySuggestion = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.propertySuggestion, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const fetchUserSuggestion = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.userSuggestion, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const addListWithUser = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.addListWithUser, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const unShareListWithUser = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.unShareListWithUser, payload, 'delete')
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const fetchProspectingSuggestion = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.prospectingSuggestion, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const fetchPropertySearchResult = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.propertySearch, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const fetchPropertySearchResultForExport = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.exportPropertySearch, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const fetchAccountSuggestion = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.accountSuggestion, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const fetchSavedSearches = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.getSavedSearch, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const saveSavedSearch = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.saveSavedSearch, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const deleteSavedSearch = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.deleteSavedSearch, payload, 'delete')
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const fetchUserInfo = payload => {
    try {
        return APIInterceptor(propertySearchAPIs.getUserInfo, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const getPropertyPhotos = payload => {
    try {
        return APIInterceptor(window.REACT_GLOBAL_CONFIG.Polaris_Photo_API + propertySearchAPIs.queryPhoto, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

export { getCompsReport, fetchPropertySuggestion, fetchProspectingSuggestion, fetchPropertySearchResult, fetchAccountSuggestion, fetchSavedSearches, saveSavedSearch, deleteSavedSearch, fetchUserInfo, fetchUserSuggestion, addListWithUser, unShareListWithUser, fetchDeals, addListToDeal, deleteListFromDeal, fetchPropertySearchResultForExport, getPropertyPhotos }
